import React from 'react'

const OurMission = () => {
    return (
        <div>OurMission</div>
    )
}

export default OurMission